import { Referral } from '@office-start/telemetry-types';
import { containGuid } from './containGuid';
export function getReferral(referral) {
    var trimReferral = referral.replace(/Shell/, '');
    // Referral string is in Referral enum values
    var inReferral = Object.values(Referral).find(function (x) { return x === trimReferral; });
    if (inReferral) {
        return trimReferral;
    }
    // Referral string is dynamics app format
    if (isDynamicsApp(trimReferral)) {
        return Referral.DynamicsApp;
    }
    // Referral id contain guid format
    if (containGuid(trimReferral)) {
        if (isGraphApp(trimReferral)) {
            return Referral.GraphApp;
        }
        else if (isLineOfBusinessApp(trimReferral)) {
            return Referral.LineOfBusinessApp;
        }
        else if (isSharePointApp(trimReferral)) {
            return Referral.SharePointApp;
        }
        else if (isPowerAppsApp(trimReferral)) {
            return Referral.PowerAppsApp;
        }
        // for example: fe2e9079-1843-4d4c-8c4e-0bff29e1cb44
        return Referral.ThirdPartyApp;
    }
    switch (trimReferral) {
        case 'Admin':
            return Referral.AdminPortal;
        case 'UpcomingMeeting':
            return Referral.Calendar;
        case 'Document':
        case 'Documents':
        case 'OneDrive':
            return Referral.Documents;
        case 'Forms':
        case 'OfficeForms':
            return Referral.OfficeForms;
        case 'Lists':
        case 'List':
            return Referral.Lists;
        case 'MeetingObject':
            return Referral.MeetingObject;
        case 'M365app':
            return Referral.MetaOSApp;
        case 'Office':
            return Referral.OfficeDotCom;
        case 'MicrosoftPowerBI':
        case 'PowerBI':
        case 'PowerBIv2':
            return Referral.PowerBI;
        case 'SharePoint':
        case 'Sites':
            return Referral.SharePoint;
        case 'Streams':
        case 'Stream':
            return Referral.MicrosoftStream;
        case 'Teams':
            return Referral.SkypeTeams;
        default:
            return Referral.UnknownApp;
    }
}
/**
 * Check if value contain a Dynamics app id prefix
 * For example: Microsoft.BusinessAppDiscovery/app/Attract
 *              Microsoft.BusinessAppDiscovery/app/8b9bb9de-3a50-430c-97c6-63c001713b6a
 *              Microsoft.BusinessAppDiscovery/app/8e9002c0-a1d8-4465-b952-817d2948e6e2-sandbox
 *              Microsoft.BusinessAppDiscovery/app/abb.crm.dynamics.com_16063d95-c1cf-eb11-bacc-000d3a573895
 * @param {string} app value
 */
function isDynamicsApp(app) {
    return new RegExp('Microsoft.BusinessAppDiscovery').test(app);
}
/**
 * Check if value contain a Power app id prefix
 * For example: providers/Microsoft.PowerApps/apps/f036d35a-be53-bf58-5760-2556b7d93fdc
 * @param {string} app value
 */
function isPowerAppsApp(app) {
    return new RegExp('providers/Microsoft.PowerApps').test(app);
}
/**
 * Check if value contain a Graph app id prefix
 * For example: GraphApp_{72FC4EF7-8FDA-4C49-B1A5-F587ECB3F75B}
 * @param {string} app value
 */
function isGraphApp(app) {
    return new RegExp('GraphApp').test(app);
}
/**
 * Check if value contain a LineOfBusinessApp app id prefix
 * For example: LineOfBusinessApp_{72FC4EF7-8FDA-4C49-B1A5-F587ECB3F75B}
 * @param {string} app value
 */
function isLineOfBusinessApp(app) {
    return new RegExp('LineOfBusinessApp').test(app);
}
/**
 * Check if value contain a SharePointApp app id prefix
 * For example: {444D31D7-AA67-4AB1-8425-84A5BDDF2B9B}|{BF075425-80D1-4DF6-8B24-EC4AEFB48A5F}
 *              SharePointApp_{B61B3A96-DA36-487B-B61B-210464F08F8A}|{CDB1E2DD-193E-43C4-B27B-C1981206DD5A}
 * @param {string} app value
 */
function isSharePointApp(app) {
    return (new RegExp('SharePointApp').test(app) ||
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(app));
}
//# sourceMappingURL=getReferral.js.map